import React from 'react';

const PageIntro: React.FC<{ eyebrow: string; title: React.ReactNode; lede?: React.ReactNode; children?: React.ReactNode }> = ({ eyebrow, title, lede, children }) => (
  <section className="intro">
    <div className="wrap reveal">
      <div className="eyebrow">{eyebrow}</div>
      <h1>{title}</h1>
      {lede && <p className="lede">{lede}</p>}
      {children}
    </div>
  </section>
);

export default PageIntro;
